import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const audioVideoInmateAccountPaymentRoutes: RouteObject[] = [
  {
    path: '/av-inmate-account-payment',
    element: lazyElement(() => import('./Search')),
    handle: {
      documentTitle: 'AV Wallet Payments',
      crumb: () => ({ label: 'AV Wallet Payments', to: '/av-inmate-account-payment' })
    },
  },
];

export default audioVideoInmateAccountPaymentRoutes;
